const SCREENS = {
  sm: 640,
  md: 768,
  lg: 1080,
  xl: 1280,
  '2xl': 1366,
  '3xl': 1440,
  '4xl': 1920,
};

// Kept in JS (not shared/BIDS/consts.ts) because tailwind.config.js requires it directly at build
// time, with no TypeScript loader registered for that require.
const TREMOR_COLORS = {
  gold: '#B4985A',
  burgundy: '#8A1538',
  stone: '#D8CFC6',
  grape: '#985F73',
  olive: '#8B704B',
  neutral: '#CBAFB9',
  gray: '#909192',
};

module.exports = {
  SCREENS: SCREENS,
  TREMOR_COLORS: TREMOR_COLORS,
};
